<template>
	<!-- 重大隐患上报管理 -->
	<section>
		<!--工具条-->
		<el-col  :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item v-if="bquery">
					<el-input v-model="filters.companyName" placeholder="企业名称"></el-input>
				</el-form-item>
				<el-form-item v-if="bquery">
					<el-button type="primary" v-on:click="getPageList">查询</el-button>
				</el-form-item>
				<el-form-item  v-if="bshow">
					<el-button type="primary" v-on:click="showAddyhpcReport">上报重大隐患</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="pagelist" highlight-current-row v-loading="listLoading"  style="width: 100%;">
			<el-table-column prop="coName" label="企业名称" min-width="200" align="center">
			</el-table-column>
			<!-- <el-table-column prop="cityName" label="所属城市" min-width="100" align="center">
			</el-table-column> -->
      		<el-table-column prop="findTime" label="隐患发现时间" align="center" min-width="150">
			</el-table-column>
			<el-table-column prop="selfCheckLocationName" label="发现场所" align="center" min-width="150">
			</el-table-column>
			<el-table-column prop="workerName" label="发现人员" align="center" min-width="100">
			</el-table-column>
 			<el-table-column prop="findContent" label="隐患内容" align="center" min-width="150">
			</el-table-column>
			<el-table-column prop="planCorrectTime" label="整改计划完成时间" align="center"  min-width="150">
			</el-table-column>
			<el-table-column prop="dangerStatusName" label="隐患状态" align="center"  min-width="100">
			</el-table-column>
      		
			<el-table-column prop="correctUserName" label="整改负责人" align="center" min-width="150">
			</el-table-column>
 			<el-table-column prop="correctContent" label="整改措施" align="center" min-width="150">
			</el-table-column>
			<el-table-column prop="correctTime" label="整改完成时间" align="center"  min-width="200">
			</el-table-column>

			<el-table-column prop="reviewUserName" label="验收人" align="center" min-width="150">
			</el-table-column>
 			<el-table-column prop="reviewContent" label="验收内容" align="center" min-width="150">
			</el-table-column>
			<el-table-column prop="reviewTime" label="验收时间" align="center"  min-width="200">
			</el-table-column>

			<el-table-column  label="操作" align="left" width="300">
				<template slot-scope="scope">
					<el-button  type="primary"  size="small" @click="yhDetail(scope.$index, scope.row)">隐患详情</el-button>
					<el-button  v-if="bshow&&(scope.row.dangerStatusName=='整改中')" type="success" size="small" @click="handleUploadPic(scope.$index, scope.row)">上传隐患照片</el-button>
					<el-button  v-if="bshow&&(scope.row.dangerStatusName=='验收中')" type="warning" size="small" @click="handleUploadPic(scope.$index, scope.row)">上传整改照片</el-button>
					<el-button   v-if="bshow&&(scope.row.dangerStatusName=='整改中')" type="info" size="small" @click="handleZG(scope.$index, scope.row)">整改完成</el-button>
					<el-button   v-if="bshow&&(scope.row.dangerStatusName=='验收中')" type="danger" size="small" @click="handleYS(scope.$index, scope.row)">验收完成</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="total,prev, pager, next" @current-change="handleCurrentChange" :page-size="20" :total="total" style="float:right;">
			</el-pagination>
		</el-col>

		<!--设置整改信息-->
		<el-dialog :title="zgFormTitle" v-model="zgFormVisible" :close-on-click-modal="false">
      		<el-form :model="zgForm" label-width="200px" :rules="zgFormRules" ref="zgForm">	
				
					<el-form-item label="整改负责人" >
						<el-select v-model="workerId" placeholder="请选择" >
							<el-option v-for="item in companymemberlist" :key="item.Mpid" :label="item.name+'('+item.workerTypeName+')'" :value="item.workerId"></el-option>
						</el-select>
					</el-form-item>

						<el-form-item label="整改完成日期" prop="correctTime">
						<el-date-picker v-model="zgForm.selCorrectTime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
					</el-form-item>

					<el-form-item label="整改措施" prop="correctContent">
						<el-input v-model="zgForm.correctContent" auto-complete="off"></el-input>
					</el-form-item>
      		</el-form>
      
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="zgFormVisible = false">关闭</el-button>
				<el-button type="primary" @click.native="updateZgInfo" :loading="editLoading">保存</el-button>
			</div>
		</el-dialog>

		<!--设置验收信息-->
		<el-dialog :title="ysFormTitle" v-model="ysFormVisible" :close-on-click-modal="false">
      		<el-form :model="ysForm" label-width="200px" :rules="ysFormRules" ref="ysForm">	
				
					<el-form-item label="验收人" >
						<el-select v-model="workerId" placeholder="请选择" >
							<el-option v-for="item in companymemberlist" :key="item.Mpid" :label="item.name+'('+item.workerTypeName+')'" :value="item.workerId"></el-option>
						</el-select>
					</el-form-item>

						<el-form-item label="验收日期" prop="reviewTime">
						<el-date-picker v-model="ysForm.selReviewTime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
					</el-form-item>

					<el-form-item label="验收内容" prop="reviewContent">
						<el-input v-model="ysForm.reviewContent" auto-complete="off"></el-input>
					</el-form-item>
      		</el-form>
      
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="ysFormVisible = false">关闭</el-button>
				<el-button type="primary" @click.native="updateYsInfo" :loading="editLoading">保存</el-button>
			</div>
		</el-dialog>

		<!--详情界面-->
		<el-dialog  title="隐患详情" v-model="detailFormVisible" :close-on-click-modal="false">

			<div class="grid-content bg-purple">
				<label>企业名称:  {{detailForm.coName}}</label>
			</div>

			<div class="grid-content bg-purple">
				<label>隐患状态:  {{detailForm.dangerStatusName}}</label>
			</div>

			<div class="grid-content bg-purple">
				<label>隐患内容:  {{detailForm.findContent}}</label>
			</div>

			<div  v-if="picList0.length!=0" style="margin-top: 20px;">
				<label>隐患照片</label>
			</div>
			<div  v-if="picList0.length!=0">
				<div class="image-container">
					<div v-for="(item, index)  in picList0" :key="index" class="image-item">
					<img :src="picbaseurl+item.picUrl" alt="Image" @click.self="showBigImage(picbaseurl+item.picUrl)">
					</div>
				</div>
			</div>
			<hr  v-if="picList0.length!=0">
			<div  v-if="picList1.length!=0" class="grid-content bg-purple">
				<label>整改照片</label>
			</div>
			<div v-if="picList1.length!=0" >
				<div class="image-container">
					<div v-for="(item, index)  in picList1" :key="index" class="image-item">
					<img :src="picbaseurl+item.picUrl" alt="Image" @click.self="showBigImage(picbaseurl+item.picUrl)">
					</div>
				</div>
			</div>

			<div slot="footer" class="dialog-footer">
				<el-button @click.native="detailFormVisible = false">关闭</el-button>
			</div>
		</el-dialog>

		<!--4-2显示放大图片的组件-->
		<BigImg :visible="photoVisible" :url="bigImgUrl" @closeClick="()=>{photoVisible=false}"></BigImg>

		<el-dialog title="上报重大隐患" v-model="addyhpcFormVisible" :close-on-click-modal="false" >
			<el-form :label-position="labelPosition" :model="addyhpcForm" label-width="140px" :rules="addyhpcFormRules" ref="addyhpcForm">
				<el-row>
				<el-col :span="11"> 
					<el-form-item label="发现场所" >
							<el-select v-model="selfCheckLocationvalue" placeholder="请选择" >
								<el-option v-for="item in selfCheckLocationoptions" :key="item.Mpid" :label="item.MpCn" :value="item.MpValue"></el-option>
							</el-select>
						</el-form-item>
				</el-col>
				<el-col :span="11" >      
					<el-form-item label="发现人员" >
						<el-select v-model="workerId" placeholder="请选择" >
							<el-option v-for="item in companymemberlist" :key="item.Mpid" :label="item.name+'('+item.workerTypeName+')'" :value="item.workerId"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
			    </el-row>

				<el-row>					   
					<el-form-item label="隐患发现时间" prop="findTime">
						<el-date-picker v-model="addyhpcForm.selFindTime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
					</el-form-item>
			    </el-row>
				<el-row>					   
					<el-form-item label="隐患内容" prop="findContent">
						<el-input v-model="addyhpcForm.findContent" auto-complete="off"></el-input>
					</el-form-item>
			    </el-row>

				<el-row>
					<el-form-item label="整改计划完成时间" prop="planCorrectTime">
						<el-date-picker v-model="addyhpcForm.selPlanCorrectTime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
					</el-form-item>	
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="addyhpcFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="handleAddyhpczl">提交</el-button>
			</div>
		</el-dialog>

		<el-dialog :title="uploadpicTitle" v-model="yhpicFormVisible" :close-on-click-modal="false">
      		<el-form :model="yhpicForm" label-width="100px" :rules="yhpicFormRules" ref="yhpicForm">	
				<el-form-item label="上传照片" >
					<div>
						<input  ref="upLoadRef" type="file" @change.stop="handleFileUpload">
						<button  v-show="uploadstart" @click.stop.prevent="uploadReportFile">上传</button>
					</div>
				</el-form-item>
				请提前准备好照片，上传文件成功后，再点击保存。
      		</el-form>
      
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="yhpicFormVisible = false">关闭</el-button>
				<el-button type="primary" @click.native="updateReportPic" :loading="yhpicLoading">保存</el-button>
			</div>
		</el-dialog>

	</section>
</template>

<script>
	// 4-1 
	import BigImg from "../../components/big-img"
	import axios from 'axios';
	import { selfCheckReportList,addSelfCheckReport,addReportPic,updateZgInfo,allWorkerList,updateYsInfo,getparamsByType} from '../../api/api';


	export default {
		components:{
			BigImg:BigImg
    	},
		data() {
			return {
				objectId:0, //当前登录的用户id，新增会用到
				coId:0, //当前登录的用户企业id

				bquery:false,//管理员权限
				bshow:false,//是否显示操作按钮

				filters: {
					companyName: ''
				},
				pagelist: [],
				total: 0,
				page: 1,
				listLoading: false,

				//隐患详情
				detailFormVisible: false,
				picList0:[],  //隐患照片
				picList1:[],  //整改照片
				
				detailForm: {
					coName:"",	
					findContent:"",	 
					dangerStatusName:"",					
				},

				//编辑
				editLoading: false,
				zgFormTitle:'',  //编辑的时候，显示企业名称
				zgFormVisible: false, 
				zgFormRules: {
					correctTime: [{ required: true, message: "请选择整改日期", trigger: "blur" }],	
					correctContent: [{ required: true, message: "请输入整改措施", trigger: "blur" }],	
				},
				
				zgForm: {
					checkNumber:"",
					correctUserId:0,
					correctContent:"",
					correctTime:"",
					selCorrectTime:null,
				},

				ysFormTitle:'',  //编辑的时候，显示企业名称
				ysFormVisible: false, 
				ysFormRules: {
					reviewTime: [{ required: true, message: "请选择验收日期", trigger: "blur" }],	
					reviewContent: [{ required: true, message: "请输入验收说明", trigger: "blur" }],	
				},
				
				ysForm: {
					checkNumber:"",
					reviewUserId:0,
					reviewContent:"",
					reviewTime:"",
					selReviewTime:null,
				},
				//上传通知书
				uploadstart:true,
				imageFile: null,

				picbaseurl:"https://aqjg.ycsyzglj.com/",

				// 4-5
				photoVisible:false,
				bigImgUrl:"",

				//新增
				selfCheckLocationoptions: [], 
				selfCheckLocationvalue:'',

				addyhpcFormVisible: false, 
				addyhpcFormRules: {
					findContent: [{ required: true, message: "请输入重大隐患内容", trigger: "blur" }],
					findTime: [{ required: true, message: "请选择重大隐患发现日期", trigger: "blur" }],	
					planCorrectTime: [{ required: true, message: "请选择整改计划完成时间", trigger: "blur" }],		
				},
				
				addyhpcForm: {
					createUserId:0,
					coId:0,

					findContent:"",
					findTime:"",     
					selFindTime:null,

					planCorrectTime:"",     
					selPlanCorrectTime:null,

					workerId:0,
					selfCheckLocation:''
				},
				labelPosition: 'right',

				uploadpicTitle:'',  //上传的时候，显示企业名称
				
				yhpicFormVisible: false, 
				yhpicLoading: false,
				yhpicFormRules: {
				},
				
				yhpicForm: {
					createUserId:0,
					checkNumber:"",
					picType:'0',
					picUrl:''
				},

				companymemberlist: [],
				workerId:0,
			}
		},
		methods: {
			getQYPCCSdic() {
				let para={
					MpType:"QYPCCS",
					MpParentId:"201"
				}
				getparamsByType(para).then((res) => {
					if(res.data.code==0){
						this.selfCheckLocationoptions  =res.data.data
						this.selfCheckLocationvalue=this.selfCheckLocationoptions[0].MpValue
					}
				});  
			},
			showAddyhpcReport: function (index, row) {
			
					this.addyhpcForm={
						createUserId:this.objectId,
						coId: this.coId,
						findContent:"",
						findTime:"",     
						selFindTime:null,
						
						selfCheckLocation:'',
						workerId:0,
						planCorrectTime:"",     
						selPlanCorrectTime:null,
					},

					this.addyhpcFormVisible=true
					//没有人员的时候，不显示备选
					if (this.workerId==0) {
						this.workerId=''
					} 
				
			},
			handleAddyhpczl: function () {
				if(this.workerId=='')
				{
					this.$message.error("请选择发现人员");
				}
				else{
					if(this.addyhpcForm.selFindTime!=null){
						this.addyhpcForm.findTime = this.addyhpcForm.selFindTime.toLocaleString();
					}

					if(this.addyhpcForm.selPlanCorrectTime!=null){
						this.addyhpcForm.planCorrectTime = this.addyhpcForm.selPlanCorrectTime.toLocaleString();
					}

					this.addyhpcForm.selfCheckLocation= this.selfCheckLocationvalue
					this.addyhpcForm.workerId= this.workerId

					this.$refs.addyhpcForm.validate((valid) => {
						if (valid) {
							this.$confirm('确认上报重大隐患吗？', '提示', {}).then(() => {						
								addSelfCheckReport(this.addyhpcForm).then((res) => {
										if(res.data.code==0){
											this.addyhpcFormVisible = false;
											this.$message.success(res.data.message);
											this.getPageList()
										}
										else{
											this.$message.error(res.data.message);
										}
								});
							});	
						}
					});
				}	
			},
			handleFileUpload(event) {
				let filearr = event.target.files[0].name.split('.');

				if(filearr[1]=='png'||filearr[1]=='jpg'||filearr[1]=='jpeg'){
					this.imageFile = event.target.files[0];
				}else{
					this.imageFile = null;
					this.$message.error("请选择png或jpg格式的文件");
				}
			},
			uploadReportFile() {
				if(this.imageFile!=null){
					let formData = new FormData();
					formData.append('file', this.imageFile);
					formData.append('filetype', "companyArchive");
					formData.append('secondarydir', "yhpczl_com_"+this.objectId);
					axios.post('/yhpczl/mgr/v1/uploadFile', formData, {
						headers: {
						'Content-Type': 'multipart/form-data'
						}
					}).then(response => {					
						if (response.data.code==0) {
							this.yhpicForm.picUrl = response.data.data.url;
							this.uploadstart=false
							this.$message.success("文件上传成功，请点击保存");
						} else {
							this.$message.error("文件上传失败，请重新提交");
						}
					});
				}else{
					this.$message.error("请选择文件后再点击【上传】按钮");
				}
				
			},
			//4-4点击图片函数，点击后，把photoVisible设置成true
			showBigImage(e) {
				if (e != "") {
					this.photoVisible = true;
					this.bigImgUrl = e;
				}
			},
			handleCurrentChange(val) {				
				this.page = val;
				this.getPageList();
			},
			//获取分页列表
			getPageList() {
				let para = {
					page: this.page,
					pageSize:20,
					objectId:this.objectId,
					coName: this.filters.companyName,
					checkType:"view",
				};

				this.listLoading = true;

				selfCheckReportList(para).then((res) => {
					if(res.data.code==0){
						this.total = res.data.data.total;
						this.pagelist = res.data.data.list;
					}
					this.listLoading = false;
				});
			},
			handleZG: function (index, row) {
				this.zgFormVisible = true;

				this.zgFormTitle = row.coName +" 整改信息"
				
				this.zgForm={
					checkNumber: row.checkNumber,
					correctUserId:0,
					correctContent:"",
					correctTime:"",
					selCorrectTime:null,
				}
				//没有人员的时候，不显示备选
				if (this.workerId==0) {
					this.workerId=''
				} 	
			},
			updateZgInfo: function () {
				if(this.workerId=='')
				{
					this.$message.error("请选择整改负责人");
				}
				else{
					if(this.zgForm.selCorrectTime!=null){
						this.zgForm.correctTime = this.zgForm.selCorrectTime.toLocaleString();
					}
				
					this.$refs.zgForm.validate((valid) => {
						if (valid) {
							this.$confirm('确认完成整改吗？', '提示', {}).then(() => {
							this.editLoading = true;
							this.zgForm.correctUserId=this.workerId
							
							updateZgInfo(this.zgForm).then((res) => {
									this.editLoading = false;
									this.zgFormVisible = false;
									if(res.data.code==0){
										this.$message.success(res.data.message);
										this.getPageList();
									}
									else{
										this.$message.error(res.data.message);
									}
						

								});
							});
						}
					});
				}
			},	
			handleYS: function (index, row) {
				this.ysFormVisible = true;
				this.ysFormTitle = row.coName +" 验收信息"
				this.ysForm={
					checkNumber: row.checkNumber,
					reviewUserId:0,
					reviewContent:"",
					reviewTime:"",
					selReviewTime:null,
				}
			},
			updateYsInfo: function () {
				if(this.ysForm.selReviewTime!=null){
					this.ysForm.reviewTime = this.ysForm.selReviewTime.toLocaleString();
				}
				this.$refs.ysForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认验收完成吗？', '提示', {}).then(() => {
						this.editLoading = true;
						this.ysForm.reviewUserId=this.workerId
						
						updateYsInfo(this.ysForm).then((res) => {
								this.editLoading = false;
								this.ysFormVisible = false;
								if(res.data.code==0){
									this.$message.success(res.data.message);
									this.getPageList();
								}
								else{
									this.$message.error(res.data.message);
								}
					

							});
						});
					}
				});
			},	
			yhDetail: function (index, row) {
				this.detailForm.coName=row.coName
			
				this.detailForm.findContent = row.findContent 
				this.detailForm.dangerStatusName=row.dangerStatusName

				this.picList0=[]
				this.picList1=[]
				for (let index = 0; index < row.picList.length; index++) {
					const element = row.picList[index];

					if (element.picType=='0') {
						this.picList0.push(element)
					} else {
						this.picList1.push(element)
					}
					
				}
				this.detailFormVisible=true
			},	
			handleUploadPic: function (index, row) {
				if(row.dangerStatusName=='整改中'){
					this.uploadpicTitle = row.coName+' 隐患照片'

					this.yhpicForm={
						createUserId:this.objectId,
						checkNumber: row.checkNumber,
						picType:"0", 
						picUrl:''    
					}
				}else{
					this.uploadpicTitle = row.coName+' 整改照片'

					this.yhpicForm={
						createUserId:this.objectId,
						checkNumber: row.checkNumber,
						picType:"1", 
						picUrl:''    
					}
				}
				this.imageFile = null;
				this.yhpicFormVisible = true;
				this.uploadstart=true
				if (this.$refs.upLoadRef) {
					this.$refs.upLoadRef.value = '' // 置空input文件
				}

			},
			updateReportPic: function () {
				if (this.yhpicForm.picUrl=='') {
					this.$message.error("图片不存在，请上传文件后再点击保存");
				} else {
					this.$refs.yhpicForm.validate((valid) => {
						if (valid) {
							this.$confirm('确认提交照片吗？', '提示', {}).then(() => {
							this.yhpicLoading = true;
		
							addReportPic(this.yhpicForm).then((res) => {
									this.yhpicLoading = false;
									this.yhpicFormVisible = false;
									if(res.data.code==0){
										this.$message.success(res.data.message);
										this.getPageList();
									}
									else{
										this.$message.error(res.data.message);
									}
						

								});
							});
						}
					});
				}
			},	
			//获取企业全部人员列表
			getAllWorkerList() {
				let para = {
					coId:this.coId,
				};

				allWorkerList(para).then((res) => {
					if(res.data.code==0){
						this.companymemberlist = res.data.data;
						this.workerId=this.companymemberlist[0].workerId
					}
				});
			},
		},
		mounted() {			
			let user = JSON.parse(sessionStorage.getItem('user'));
			this.objectId = user.data.userId
			this.coId = user.data.coId

			if (user.data.roleId=="4") {
				this.filters.companyName = user.data.userName	
				this.bshow=true
				this.bquery=false
				this.getAllWorkerList();
			} else {
				this.bquery=true
				this.bshow=false
			}

			this.getPageList();
			this.getQYPCCSdic();
			
		}
	}

</script>

<style scoped>
	
	
</style>


// WEBPACK FOOTER //
// selfcheckReport.vue?42d288df